import { get } from './request.js'

export function getInfo({ success, fail, complete }) {
  get('/api/user/getInfo', {
    showLoading: false,
    showError: false,
    success,
    fail,
    complete,
  })
}